var map = {
	"./Resized_20240302_114205_1722645403701.jpeg": 458,
	"./Resized_20240430_123804_1722645580139.jpeg": 174,
	"./Resized_20240723_095433_1722645650065.jpeg": 791,
	"./Resized_20240731_093313_1722645713694.jpeg": 255,
	"./Resized_20240731_093751_1722645677929.jpeg": 856,
	"./image1.jpeg": 600
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 677;